import React from 'react';
import { useMediaQuery } from '@material-ui/core';
import { Stack } from '@mui/material';
import { getUser } from '../../../../../utils';
import { CreationMenuButton, SwitchUserButton, NotificationAPIButton, UserMenuButton } from './components';
import SupportButton from '../../../../custom-components/SupportButton';

const ToolbarV2 = () => {
    const user = getUser();
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));

    return (
        <div
            style={{
                display: 'flex',
                marginTop: isMobile ? '4px' : '7px',
                gap: isMobile ? null : '12px',
                // wrap
            }}
        >
            <SwitchUserButton user={user} isMobile={isMobile} />
            <Stack direction="row" alignItems="center" spacing={1}>
                <NotificationAPIButton userId={user.id} />
                <CreationMenuButton user={user} />
                <SupportButton />
                <UserMenuButton user={user} />
            </Stack>
        </div>
    );
};

export default ToolbarV2;
